function Navigation() {

    let trigger = document.querySelectorAll('.main-menu__item');
    let main = document.querySelector("main");
    let overlay = document.querySelector(".overlay--main");

    function toggleDropDown(e) {
        if(this.children.length > 1){
            Array.prototype.forEach.call(trigger, (node) => {
                node.classList.remove('main-menu__item--open');
                main.classList.remove('main--open-nav');
            });
            this.classList.toggle('main-menu__item--open');
            main.classList.toggle('main--open-nav');
        }
    }
    
    function removeOpenNav(e) {
        //this.classList.remove('main-menu__item--open');
        main.classList.remove('main--open-nav');
        Array.prototype.forEach.call(trigger, (node) => {
            node.classList.remove('main-menu__item--open');
        });
    }

    Array.prototype.forEach.call(trigger, (node) => {
        node.addEventListener('mouseenter', toggleDropDown)
    })

    overlay.addEventListener('mouseenter', removeOpenNav);
}

export default Navigation;


// WEBPACK FOOTER //
// ./src/js/app/components/Navigation.js